import i18n from '@/locales/i18n';
import isCompanyUser from '@produtos/store-access-provider/src/utils/is-company-user';
import isInnerUser from '@produtos/store-access-provider/src/utils/is-inner-user';

export default /** @type { import('vuex').Module } */ ({
  namespaced: true,

  state: {
    menus: {
      dashboard: {
        icon: 'mdi-view-dashboard-outline',
        label: 'Dashboard',
        to: '/',
      },
      applications: {
        icon: 'mdi-cellphone',
        label: i18n.t('applications.application'),
        to: '/applications',
      },
      companies: {
        icon: 'mdi-store',
        label: i18n.t('companies.companies'),
        to: '/companies',
      },
      myapplications: {
        icon: 'mdi-cellphone',
        label: i18n.t('applications.application'),
        to: '/myapplications',
      },
      myusers: {
        icon: 'mdi-account-supervisor',
        label: i18n.t('users.users'),
        to: '/myusers',
      },
      // users: {
      //   icon: 'mdi-account-group-outline',
      //   label: 'Users',
      //   to: { name: 'users', params: { companyId: null } },
      // },
      // services: {
      //   icon: 'mdi-hexagon-multiple-outline',
      //   label: 'Services',
      //   to: '/services',
      // },
    },
  },

  getters: {
    services: (state, getters, rootState, rootGetters) => rootGetters['accessProvider/services'],
    pin: (state, getters, rootState, rootGetters) => rootGetters['settingsProvider/pin'],
    menus: (state, getters, rootState, rootGetters) => {
      const profile = rootGetters['auth/profile'];

      if (isCompanyUser(profile?.tags)) {
        return [
          state.menus.myusers,
          state.menus.myapplications,
        ];
      }

      if (isInnerUser(profile?.tags)) {
        return [
          state.menus.applications,
          state.menus.companies,
        ];
      }

      return [
        state.menus.dashboard,
      ];
    },
  },
});
